import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { DimensionsUnitsEnum } from 'src/app/core/enums/dimensions-units.enum';
import { WeightUnitsEnum } from 'src/app/core/enums/weight-units.enum';
import convertWeight from 'src/app/core/helpers/convert-weight';
import convertDimensions from 'src/app/core/helpers/dimensions-weight';
import { packageValidator } from 'src/app/core/validators/package-validator';
import { Product } from 'src/app/PIM/models/product.model';

@Component({
  selector: 'app-add-product-dimensions',
  templateUrl: './add-product-dimensions.component.html',
})
export class AddProductDimensionsComponent implements OnInit {
  @Output() onSave = new EventEmitter();

  @Output() onCancel = new EventEmitter();

  submitted = false;

  form = this.fb.group(
    {
      productWidth: [null as number | null, [Validators.min(0), Validators.required]],
      productHeight: [null as number | null, [Validators.min(0), Validators.required]],
      productLength: [null as number | null, [Validators.min(0), Validators.required]],
      productWeight: [null as number | null, [Validators.min(0), Validators.required]],
      packageWidth: [null as number | null, [Validators.min(0)]],
      packageHeight: [null as number | null, [Validators.min(0)]],
      packageLength: [null as number | null, [Validators.min(0)]],
      packageCapacity: [null as number | null, [Validators.min(0)]],
    },
    { validators: packageValidator },
  );

  constructor(private fb: FormBuilder, private dialogRef: MatDialog, @Inject(MAT_DIALOG_DATA) public data: Product) { }

  ngOnInit(): void {
    this.form.patchValue({
      productWidth: convertDimensions(this.data?.dimensions?.width) || null,
      productHeight: convertDimensions(this.data?.dimensions?.height) || null,
      productLength: convertDimensions(this.data?.dimensions?.length) || null,
      productWeight: convertWeight(this.data?.weight) || null,
      packageWidth: convertDimensions(this.data?.package?.dimensions?.width) || null,
      packageHeight: convertDimensions(this.data?.package?.dimensions?.height) || null,
      packageLength: convertDimensions(this.data?.package?.dimensions?.length) || null,
      packageCapacity: this.data?.package?.capacity || null,
    });
    Object.keys(this.form.controls).forEach(key => {
      const control = this.form.controls[key];
      if(control.value) {
        control.disable();
      }
    })
  }

  save(): void {
    this.submitted = true;

    if (this.form.valid) {
      Object.keys(this.form.controls).forEach(key => {
        const control = this.form.controls[key];
        if(control.value) {
          control.enable();
        }
      })
      const payload: Partial<Product> = {
        dimensions: {
          width: convertDimensions(this.form.value.productWidth, DimensionsUnitsEnum.CM, DimensionsUnitsEnum.MM),
          height: convertDimensions(this.form.value.productHeight, DimensionsUnitsEnum.CM, DimensionsUnitsEnum.MM),
          length: convertDimensions(this.form.value.productLength, DimensionsUnitsEnum.CM, DimensionsUnitsEnum.MM),
        },
        weight: convertWeight(this.form.value.productWeight, WeightUnitsEnum.KG, WeightUnitsEnum.G),
      };

      const hasPackageData =
        this.form.value.packageCapacity ||
        this.form.value.packageWidth ||
        this.form.value.packageHeight ||
        this.form.value.packageLength;

      if (hasPackageData) {
        payload.package = {
          capacity: this.form.value.packageCapacity,
          dimensions: {
            width: convertDimensions(this.form.value.packageWidth, DimensionsUnitsEnum.CM, DimensionsUnitsEnum.MM),
            height: convertDimensions(this.form.value.packageHeight, DimensionsUnitsEnum.CM, DimensionsUnitsEnum.MM),
            length: convertDimensions(this.form.value.packageLength, DimensionsUnitsEnum.CM, DimensionsUnitsEnum.MM),
          },
        };
      }
      
      this.onSave.emit(payload);
      this.dialogRef.closeAll();
    }
  }

  cancel(): void {
    this.onCancel.emit();
    this.dialogRef.closeAll();
  }
}
